import {
  ProjectHttpClient,
  ProjectStateManagementHttpClient,
} from '../../common/services/httpClient';

export const setProjectUserAccepted = async (projectId) => {
  const response = await ProjectHttpClient.post(
    `projects/${projectId}/projectUser`
  );
  return response.data;
};

export const getProjectDisclaimer = async (projectId) => {
  const response = await ProjectStateManagementHttpClient(projectId).get(
    `projects/${projectId}/ProjectDisclaimer`
  );

  return response.data;
};

export const updateProjectDisclaimer = async (projectId, disclaimerText) => {
  const response = await ProjectStateManagementHttpClient(projectId).put(
    `projects/${projectId}/ProjectDisclaimer`,
    {
      disclaimerHtml: disclaimerText,
      hasAccepted: true,
    }
  );
  return response.data;
};
